<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="分销商姓名：">
                <el-input v-model="searchForm.agentName"  @keyup.enter.native="getSimDistributRecordHandle"></el-input>
            </el-form-item>
            <el-form-item label="批次：">
                <el-input v-model="searchForm.batchNo"  @keyup.enter.native="getSimDistributRecordHandle"></el-input>
            </el-form-item>
            <el-form-item label="分销时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getSimDistributRecordHandle" plain icon="el-icon-search">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="startIccid" label="开始ICCID号"></el-table-column>
            <el-table-column prop="endIccid" label="结束ICCID号"></el-table-column>
            <el-table-column prop="agentName" label="分销商姓名"></el-table-column>
            <el-table-column prop="batchNo" label="批次"></el-table-column>
            <el-table-column prop="soldTotal" label="导入张数（张）"></el-table-column>
            <el-table-column prop="soldSuccess" label="导入成功张数（张）"></el-table-column>
            <el-table-column prop="soldFail" label="导入失败张数（张）"></el-table-column>
            <el-table-column prop="createTime" label="分销时间"></el-table-column>            
            <el-table-column prop="createOptName" label="操作人"></el-table-column>            
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.soldFail > 0" type="text" size="small" plain icon="el-icon-search">查看失败</el-button>
                </template> 
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog :append-to-body="true"  title="分销失败卡列表" :visible.sync="distributFailVisible" width="50%" :close-on-click-modal="false">
            <el-table :data="tableData_fail" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="failReason" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>     
    </div>
</template>
<script>
import {getSimDistributRecord} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                batchNo: '',
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            distributFailVisible: false,
            currentId_fail: '',            
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            }            
        }
    },
    methods: {
        getSimDistributRecordHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSimDistributRecord(data).then(res => {
                common.listCallback(this, res, 'tbpg');               
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSimDistributRecordHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getSimDistributRecordHandle();
        }  
    },
    created () {
        this.getSimDistributRecordHandle()
    } 
}
</script>
<style lang="less" scoped>

</style>

